export default __webpack_public_path__ + "static/media/database_green.39bf0ab1.svg";